import { render } from "./StylesGlobal.vue?vue&type=template&id=6fcaa062"
const script = {}

import "./StylesGlobal.vue?vue&type=style&index=0&id=6fcaa062&lang=css"
script.render = render

export default script